<ng-container *ngIf="config.link; else button">
  <a
    class="button clickable"
    nz-button
    [href]="config.href"
    [target]="config.target ?? '_blank'"
    [ngStyle]="config.styles"
    [ngClass]="[
      'button--color-' + (config.color ?? 'primary'),
      'button--type-' + (config.type ?? 'primary'),
    ]"
    [nzLoading]="config.isLoading$ | async"
    [nzSize]="config.size ?? 'default'"
    [nzBlock]="config.block ?? true"
  >
    <i
      *ngIf="config.prefixIcon"
      icon
      class="button__prefix"
      [iconName]="config.prefixIcon"
    ></i>
    <span>{{ config.label | transloco }}</span>
    <i
      *ngIf="config.suffixIcon"
      icon
      class="button__suffix"
      [iconName]="config.suffixIcon"
    ></i>
  </a>
</ng-container>
<ng-template #button>
  <button
    class="button clickable"
    nz-button
    [ngStyle]="config.styles"
    [ngClass]="[
      'button--color-' + (config.color ?? 'primary'),
      'button--type-' + (config.type ?? 'primary'),
    ]"
    [nzLoading]="config.isLoading$ | async"
    [nzSize]="config.size ?? 'default'"
    [nzBlock]="config.block ?? true"
    [type]="config.submit ? 'submit' : 'button'"
    (click)="onClick()"
  >
    <i
      *ngIf="config.prefixIcon"
      icon
      class="button__prefix"
      [iconName]="config.prefixIcon"
    ></i>
    <span>{{ config.label | transloco }}</span>
    <i
      *ngIf="config.suffixIcon"
      icon
      class="button__suffix"
      [iconName]="config.suffixIcon"
    ></i>
  </button>
</ng-template>
